(function () {
  var KEY = 'mez_cookie_consent';

  function load() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function save(data) {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }

  function closeModal() {
    var overlay = document.getElementById('cb-overlay');
    if (overlay) {
      overlay.classList.add('cb-hide');
      setTimeout(function () { overlay.remove(); }, 400);
    }
    document.body.style.overflow = '';
  }

  function showSettings() {
    document.getElementById('cb-notice').style.display = 'none';
    document.getElementById('cb-settings').style.display = 'block';
    document.getElementById('cb-overlay').classList.add('cb-settings-open');
  }

  function showNotice() {
    document.getElementById('cb-notice').style.display = 'block';
    document.getElementById('cb-settings').style.display = 'none';
    document.getElementById('cb-overlay').classList.remove('cb-settings-open');
  }

  function acceptAll() {
    save({ status: 'accepted', preference: true, statistics: true, marketing: true });
    document.dispatchEvent(new CustomEvent('cookie:accepted', { detail: { preference: true, statistics: true, marketing: true } }));
    closeModal();
  }

  function rejectAll() {
    save({ status: 'declined', preference: false, statistics: false, marketing: false });
    closeModal();
  }

  function savePrefs() {
    var data = {
      status: 'custom',
      preference: document.getElementById('cb-pref-accept').classList.contains('cb-toggle--active'),
      statistics: document.getElementById('cb-stat-accept').classList.contains('cb-toggle--active'),
      marketing: document.getElementById('cb-mkt-accept').classList.contains('cb-toggle--active')
    };
    save(data);
    document.dispatchEvent(new CustomEvent('cookie:accepted', { detail: data }));
    closeModal();
  }

  function bindToggle(acceptId, declineId) {
    var accept = document.getElementById(acceptId);
    var decline = document.getElementById(declineId);
    accept.addEventListener('click', function () {
      accept.classList.add('cb-toggle--active');
      decline.classList.remove('cb-toggle--active');
    });
    decline.addEventListener('click', function () {
      decline.classList.add('cb-toggle--active');
      accept.classList.remove('cb-toggle--active');
    });
  }

  function init() {
    var overlay = document.getElementById('cb-overlay');

    if (load()) {
      // Consent already stored — remove overlay so it never blocks clicks
      if (overlay) overlay.remove();
      return;
    }

    if (!overlay) return;

    document.body.style.overflow = 'hidden';
    setTimeout(function () { overlay.classList.add('cb-visible'); }, 100);

    bindToggle('cb-pref-accept', 'cb-pref-decline');
    bindToggle('cb-stat-accept', 'cb-stat-decline');
    bindToggle('cb-mkt-accept', 'cb-mkt-decline');

    document.getElementById('cb-btn-settings').addEventListener('click', showSettings);
    document.getElementById('cb-settings-close').addEventListener('click', showNotice);

    document.querySelectorAll('.cb-btn-accept-all').forEach(function (btn) {
      btn.addEventListener('click', acceptAll);
    });
    document.querySelectorAll('.cb-btn-reject-all').forEach(function (btn) {
      btn.addEventListener('click', rejectAll);
    });
    document.getElementById('cb-btn-save').addEventListener('click', savePrefs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
